/**
 * Shown while a lazily-loaded route chunk downloads.
 *
 * Deliberately reserves the same vertical rhythm as a loaded page — a KPI band
 * followed by content panels — so the layout does not jump when the real screen
 * arrives. UX-S01 requires the skeleton to preserve the final footprint.
 */
export function RouteFallback() {
  return (
    <div className="animate-pulse p-6" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading page…</span>

      <div className="mb-6 h-8 w-72 rounded-md bg-surface-sunken" />

      <div className="mb-6 grid grid-cols-2 gap-4 lg:grid-cols-4 xl:grid-cols-8">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className="h-24 rounded-lg bg-surface-sunken" />
        ))}
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div className="h-96 rounded-lg bg-surface-sunken" />
        <div className="h-96 rounded-lg bg-surface-sunken" />
        <div className="h-96 rounded-lg bg-surface-sunken" />
      </div>
    </div>
  );
}
